import Header from './Header'
import Footer from './Footer'

function Sucesiones() {
    const title = 'Sucesiones'
    return (
        <>
            <Header/>
            <main id="main">
                {/* ======= Breadcrumbs ======= */}
                <section id="breadcrumbs" className="breadcrumbs">
                  <div className="container">
                    <ol>
                      <li><a href="/">Inicio</a></li>
                      <li>{title}</li>
                    </ol>
                    {/*h2>{title}</h2*/}
                    <div className="row">
                      <div className="col-lg-6 order-1 order-lg-2" data-aos="fade-left">
                        <img src="assets/img/sucesiones.png" className="img-fluid" alt="sucesiones" style={{'padding': '5%'}} />
                      </div>
                      <div className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content" data-aos="fade-right">
                        <h3>{title}</h3>
                        <p className="fst-italic justified-text">
                          ¿Falleció un familiar y necesitás disponer de los bienes? <strong>Te acompañamos en todo el proceso sucesorio</strong> para que puedas heredar, escriturar y vender de forma rápida y segura.
                        </p>
                        <p className="justified-text">En <strong>MFV ABOGADOS</strong> nos encargamos de iniciar y llevar adelante el trámite sucesorio ante los juzgados de <strong>CABA</strong> y tribunales de <strong>Provincia de Buenos Aires</strong>, ya sea que exista testamento o no. Gestionamos la declaratoria de herederos, la inscripción de bienes y todo lo necesario para que puedas disponer del patrimonio.</p>

                        <p className='centered'><strong>El derecho a aceptar la herencia caduca a los 10 años desde la apertura de la sucesión (Art. 2288, Código Civil y Comercial).</strong></p>

                        <h4>¿Qué hacemos por vos?</h4>
                        <ul>
                          <li><i className="bi bi-check-circle" /> <strong>Inicio del juicio sucesorio</strong> — presentamos la demanda y gestionamos todo el proceso judicial en CABA o Provincia de Buenos Aires.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Declaratoria de herederos</strong> — obtenemos la resolución judicial que te reconoce como heredero legítimo.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Inscripción de bienes</strong> — tramitamos la inscripción de inmuebles, vehículos y otros activos a tu nombre.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Sucesiones con testamento</strong> — protocolización e inscripción de bienes según la voluntad del causante.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Partición de bienes</strong> — mediamos y resolvemos la distribución del patrimonio entre coherederos.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Tracto abreviado</strong> — si necesitás vender un inmueble sin esperar la inscripción a tu nombre, gestionamos la escritura directa.</li>
                        </ul>

                        <p className="justified-text"><strong>Mientras más se demora, más se complica.</strong> Cuanto antes inicies la sucesión, antes podés disponer de los bienes.</p>
                        <p className="justified-text">Por consultas o inquietudes podés escribirnos al <a className='black-link' href="https://wa.me/+5491124089830?text=Hola%2C%20necesito%20asesoramiento%20sobre%20sucesiones">11-2408-9830.</a></p>
                        <br/>
                        <a href="https://wa.me/+5491124089830?text=Hola%2C%20necesito%20asesoramiento%20sobre%20sucesiones" className="cta-button">Hablemos de tu caso</a>
                      </div>
                    </div>
                  </div>
                </section>{/* End Breadcrumbs */}
            </main>
            <Footer/>
        </>
    );
}

export default Sucesiones;
